import React from "react"
import PropTypes from "prop-types"

class Test extends React.Component {

  componentDidMount() {
    console.log('Test did mount')
  }

  componentWillMount() {
    console.log('will mount')
  }

  render() {
    return (<h1>Test</h1>)
  }
}

export default Test;
